<template>
  <div>
    <div class="jumbotron">
      <div class="mask tra"></div>
      <b-row class="pt-5 text-left text-white">
        <b-col cols="4" md="2" class="text-right">
          <b-img src="/iconss/traduttori.png" class="rounded-pill bg-white text-center p-2"></b-img>
        </b-col>
        <b-col cols="4" class="">
          <h1>Traduttori</h1>
          <p>Area riservata</p>
        </b-col>
      </b-row>
    </div>

    <b-row class="m-2 mx-auto" style="max-width: 1460px">
      <b-col cols="3" class="text-left mb-3">
        <h3>Modifica il tuo profilo</h3>
      </b-col>
      <b-col cols="7">
        <b-row cols="12">
          <b-col cols="2">
            <b-img src="/img/logo-aid.png" fluid class="align-middle"></b-img>
          </b-col>
          <b-col cols="10">
            <p class="text-left">
              Entra anche tu nel database traduttori.
              Renditi visibile alle organizzazioni accreditate che così potranno richiederti eventuali traduzioni a
              pagamento.
              Per questa ragione, inserisci nel tuo profilo tutte le informazioni importanti (le tue conoscenze, i
              settori che conosci meglio, ad es. legale, medico) e metti un segno di spunta su “Voglio che il mio
              profilo sia visibile pubblicamente” per essere scelto dalle organizzazioni accreditate.
            </p>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="2" class="text-right mb-3">
        <b-button pill size="sm" variant="primary" :to="`/translators/view/${user.id}`" class="m-2">
          <b-icon-arrow-left></b-icon-arrow-left> Torna al profilo</b-button
        >
      </b-col>
    </b-row>

    <b-row class="my-2 mx-auto rounded bg-light py-3" style="max-width: 1460px">
      <b-col cols="12" class="text-left" id="wrapper">
        <!--Ruga dati utente-->
        <b-row>
          <!--Colonna I tuoi dati-->
          <b-col cols="12" class="text-left">
            <h2>I tuoi dati</h2>
          </b-col>
          <!--Colonna Foto e Seleziona foto da PC-->
          <b-col class="text-center">
            <img
              v-if="user.foto != null && user.foto != ''"
              :src="`${apiPath}/${user.foto}`"
              v-bind="mainProps"
              class="rounded-circle"
            />
            <img v-else src="/img/default.png" v-bind="mainProps" class="rounded-circle" />
          </b-col>
          <!--Colonna Nome-->
          <b-col>
            <b-form-group id="input-group-name" label="Nome" label-for="input-name">
              <b-form-input
                id="input-name"
                v-model="user.first_name"
                required
                placeholder="Inserisci il tuo nome"
                name="first_name"
                class="rounded-pill"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <!--Colonna Cognome-->
          <b-col>
            <b-form-group id="input-group-name" label="Cognome" label-for="input-name">
              <b-form-input
                id="input-last_name"
                v-model="user.last_name"
                required
                placeholder="Inserisci il tuo cognome"
                name="last_name"
                class="rounded-pill"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <!--Colonna E-mail-->
          <b-col>
            <b-form-group id="input-group-name" label="Email" label-for="input-name">
              <b-form-input
                id="input-email_name"
                v-model="user.email"
                required
                placeholder="Inserisci la tua mail"
                name="email"
                class="rounded-pill"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <!--Ruga Trascina o Seleziona la tua foto-->
        <b-row class="mt-2">
          <b-col cols="12" class="text-left">
            <h5>La tua foto</h5>
          </b-col>
          <b-col cols="4">
            <b-form-file
              name="foto"
              ref="file"
              v-model="user.foto2"
              accept=".jpg, .png, .gif, .jpeg"
              placeholder="* Trascina o Seleziona un'immagine"
              class="rounded-pill"
            />
          </b-col>
        </b-row>
        <b-row>
          <h2 class="col-md-12">Le tue lingue</h2>
          <b-col md="4">
            <label>Seleziona la tua lingua <b>madre</b></label>
            <v-select
              :options="langs"
              v-model="user.mother"
              label="description"
              name="mother"
              :reduce="(langs) => langs.id"
            ></v-select>
            <!--span class="pr-1 flag">
              {{ getFlag(user.mother) }}
            </span-->
            <!--country-flag :country="getFlag(user.mother)" size="normal" /-->
          </b-col>

          <b-col md="4">
            <!--<label>Seleziona le lingue in cui sei capace di leggere <b>(Source)</b></label>-->
            <label>Traduco dalle seguenti lingue <b>(lingue sorgenti)</b></label>
            <v-select
              multiple
              :options="langs"
              v-model="user.src_lang_id"
              :reduce="(langs) => langs.id"
              label="description"
              name="src_lang"
            ></v-select>
            <!--span class="pr-2" v-for="item in user.src_lang_id" :key="item">
              <country-flag :country="getFlag(item)" size="normal" />
            </span-->
          </b-col>

          <b-col md="4">
            <!--<label>Seleziona le lingue in cui sei capace di tradurre <b>(Target)</b></label>-->
            <label>Traduco verso le seguenti lingue <b>(lingue di destinazione)</b></label>
            <v-select
              multiple
              :options="langs"
              v-model="user.dest_lang_id"
              :reduce="(langs) => langs.id"
              label="description"
              name="dest_langs"
            ></v-select>
            <!--span class="pr-2" v-for="item in user.dest_lang_id" :key="item">
              <country-flag :country="getFlag(item)" size="normal" />
            </span-->
          </b-col>
        </b-row>
        <b-row>
          <h2 class="col-md-12">La tua presentazione</h2>
          <b-col md="12" class="mt-3">
            <b-textarea v-model="user.expertise"></b-textarea>
          </b-col>
          <b-col md="6" class="mt-3">
            <label class="d-flex">
              <b-form-file
                class="d-none"
                name="cv"
                :state="Boolean(user.cv)"
                ref="file"
                v-model="user.cv"
                accept=".pdf, .doc, .docx, .odt"
                @change="onFileChange"
                placeholder="* Trascina o Seleziona il file "
              />
              <div class="d-flex my-auto ml-3">
                <input
                  type="text"
                  class="form-control btn-outline-primary rounded-pill"
                  ref="viewFile"
                  @click="$refs.file.$el.click()"
                  aria-describedby="button-addon2"
                />
                <button
                  class="btn btn-primary butFile pl-4"
                  type="button"
                  @click="$refs.file.$el.click()"
                  id="button-addon2"
                >
                  <small><strong>CARICA CV</strong></small>
                </button>
              </div>
            </label>
          </b-col>
          <b-col md="6">
            <b-form-group id="input-group-youtube" label="Link (es Dailymotion, DTube, Vimeo, Twitch, Vevo, VidLii, Odysee, ...)" label-for="input-youtube">
              <b-form-input
                id="input-youtube"
                v-model="user.youtube"
                required
                placeholder="Inserisci il link del tuo video"
                name="youtube"
                class="rounded-pill"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <!-- Modifiche al DB per il campo youtube -->
          <b-col md="12" align="center" justify="center" v-if="user.youtube != null">
            <hr class="btn-outline-info" />
            <div class="rwd-video">
              <!-- <youtube :video-id="videoId"></youtube> -->
              <video-embed :src="user.youtube"></video-embed>
            </div>
            <hr class="btn-outline-info" />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="mt-3">
            <b-form-checkbox id="input-public" v-model="user.public" name="public" class="d-flex">
              Voglio che il mio profilo sia visibile pubblicamente</b-form-checkbox
            >
          </b-col>

          <b-col md="6" class="text-right mt-3">
            <b-button pill type="submit" variant="primary" class="m-2" v-on:click="salva()">Salva</b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import util from "@/mixing/util";
import UserService from "@/services/user.service";
import { getIdFromURL } from "vue-youtube-embed";
//componente per le bandierine
//import CountryFlag from "vue-country-flag";

export default {
  //components: { CountryFlag },
  mixins: [util],
  data() {
    return {
      user_id: this.$route.params.user_id,
      file: [],
      user: { mother: "it" },
      langs: [],
      myStyle: {
        backgroundColor: "#16a085",
      },
      mainProps: {
        blank: true,
        blankColor: "#777",
        width: 125,
        height: 125,
        class: "m1",
      },
      apiPath: process.env.VUE_APP_ROOT,
    };
  },
  created() {
    UserService.getLanguages().then((response) => (this.langs = response.data));
    UserService.getUser(this.$route.params.user_id).then((response) => {
      this.user = response.data;
      if (this.user.languages !== undefined) {
        this.user.dest_langs = this.getLangsType("D");
        this.user.src_langs = this.getLangsType("S");
      }
      if (this.user.cv !== undefined) {
        this.user.cv = null;
      }
    });
  },
  methods: {
    salva: function () {
      var myForm = new FormData();
      //(db,v-model)
      myForm.set("email", this.user.email);
      myForm.set("id", this.user_id);
      myForm.set("first_name", this.user.first_name);
      myForm.set("last_name", this.user.last_name);
      myForm.set("public", this.user.public);

      if(this.user.youtube != null)
        myForm.set("youtube", this.user.youtube);

      if(this.user.expertise != null)
        myForm.set("expertise", this.user.expertise);
        
      for (var i = 0; i < this.user.dest_lang_id.length; i++) {
        myForm.append("dest_lang_id[]", this.user.dest_lang_id[i]);
      }
      for (i = 0; i < this.user.src_lang_id.length; i++) {
        myForm.append("src_lang_id[]", this.user.src_lang_id[i]);
      }
      myForm.set("mother[]", this.user.mother);
      if (this.user.cv !== undefined && this.user.cv !== null) {
        myForm.append("cv", this.user.cv);
      }
      if (this.user.foto2 !== undefined && this.user.foto2 !== null) {
        myForm.append("foto", this.user.foto2);
      }
      UserService.editUser(this.user_id, myForm).then(
        (response) => {
          console.log(response);
          this.$router.push(`/translators/view/${this.user_id}`);
        },
        (error) => {
          console.log(error.response.data.message);
          this.$bvToast.toast(error.response.data.message, {
            title: 'Errore',
            autoHideDelay: 4000,
            solid: true,
            variant:'danger',
            appendToast: false
          })
          }
      );
    },
    onFileChange(e) {
      this.$refs.viewFile.value = e.target.files[0].name;
      this.file = e.target.files[0];
    },
    getLangsType(type) {
      if (this.user.languages == undefined) {
        return null;
      }
      return this.user.languages.filter((val) => {
        if (val._joinData == undefined) {
          return false;
        }
        return val._joinData.type == type;
      });
    },
  },
  computed: {
    videoId: function () {
      return getIdFromURL(this.user.youtube);
    },
  },
};
</script>

<style scoped>
h2 {
  margin-top: 1em;
  padding-top: 0.5em;
  border-top: 1px dotted silver;
}
</style>